module.exports = __webpack_public_path__ + "img/lang-ar-hover.b8e1cf53.png";